import styles from './ListCell.module.scss';
import { ReactComponent as ArrowIcon } from '../../svg/arrow-right.svg';

const ListCell = ({ avatar, name, country, flag, onClick }) => {
  return (
    <div 
      className={styles.cell}
      onClick={onClick}
    >
      <div className={styles['avatar-wrapper']}>
        <div className={styles.avatar}>
          <img src={avatar} alt={name} />
        </div>
        <div className={styles.flag}>
          <img src={flag} alt={country} />
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.name}>{name}</div>
        {country && <div className={styles.country}>{country}</div>}
      </div>
      <div className={styles.arrow}>
        <ArrowIcon />
      </div>
    </div>
  );
};

export default ListCell;
